// extracted by mini-css-extract-plugin
module.exports = {"TagItem":"_3gyO80cFpgdZVuiG7cc5IL"};